import clsx from "clsx";
import * as React from "react";
import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";
import { SpsButton } from "../button/SpsButton";
import { ButtonKind, ButtonType } from "@spscommerce/ds-shared";

export const propTypes = {
    ...spsGlobalPropTypes,
    pinned: PropTypes.bool,
    onClear: PropTypes.func,
    footerLinks: PropTypes.element,
    controlsDisabled: PropTypes.bool,
    isOpen: PropTypes.bool
};

export type SpsAdvancedSearchProps = PropsType<typeof propTypes> &
    React.HTMLAttributes<HTMLDivElement>;

export function SpsAdvancedSearch(props: SpsAdvancedSearchProps) {
    const {
        footerLinks,
        controlsDisabled,
        isOpen,
        pinned,
        onSubmit,
        onClear,
        children,
        className,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const form = React.useRef(null);

    const handleSubmit = e => {
        e.preventDefault();
        if (typeof props.onSubmit === "function") {
            const submittedForm = e.target;
            props.onSubmit(submittedForm);
        }
    };

    const handleClear = () => {
        if (typeof props.onClear === "function") {
            props.onClear();
        }
        form.current.reset();
    };

    const toolbarClass = clsx(
        unsafelyReplaceClassName || "sps-advanced-search",
        pinned && "sps-advanced-search--pinned",
        pinned && "z-stratum-bar",
        isOpen && "sps-advanced-search--open",
        className,
    );

    return (
        <div className={toolbarClass} {...rest}>
            <form ref={form} onSubmit={handleSubmit} noValidate>
                <div className="sps-advanced-search__form">{children}</div>
                <div className="sps-advanced-search__footer">
                    {footerLinks && <div id="footer_links">{footerLinks}</div>}
                    <div className="sps-advanced-search__footer-controls">
                        <SpsButton
                            kind={ButtonKind.DEFAULT}
                            type={ButtonType.BUTTON}
                            className="mr-2"
                            onClick={handleClear}
                            disabled={controlsDisabled}
                        >
                            Clear
                        </SpsButton>
                        <SpsButton
                            kind={ButtonKind.KEY}
                            type={ButtonType.SUBMIT}
                            disabled={controlsDisabled}
                        >
                            Search
                        </SpsButton>
                    </div>
                </div>
            </form>
        </div>
    );
}

Object.assign(SpsAdvancedSearch, {
    propTypes,
    displayName: "SpsAdvancedSearch"
});
